<template>
  <div class="containter">
      <el-row>
          <el-col class="br bb" :span="8">序列号</el-col>
          <el-col class="bb" :span="16">
              {{serialNumber}}
          </el-col>
          <el-col class="br bb" :span="8">组态</el-col>
          <el-col class="bb" :span="16">
            <el-button :disabled="equipment_model == ''?true:false" @click="realInfo" type="text" size="small">跳转</el-button>
          </el-col>
          <el-col class="br bb" :span="8">趋势图</el-col>
          <el-col class="bb" :span="16">
            <el-button @click="charts" type="text" size="small">跳转</el-button>
          </el-col>
          <el-col class="br bb" :span="8">告警</el-col>
          <el-col class="bb" :span="16">
            <el-button @click="alert" type="text" size="small">跳转</el-button>
          </el-col>
          <el-col class="br" :span="8">控制</el-col>
          <el-col :span="16">
            <el-button @click="control" type="text" size="small">跳转</el-button>
          </el-col>
      </el-row>
  </div>
</template>

<script>
export default {
    name:"mapInfo",
    props:{
        serialNumber:String,
        templateName:String,
        equipment_model:String
    },
    methods:{
        //跳转实时数据页面
        realInfo(){
        let route = this.$router.resolve({
            path:'/getewayRealInfo',
            query:{
                serial_number:this.serialNumber,
                templateName:this.templateName,
                equipment_model:this.equipment_model,
            }
        })
        window.open(route.href,'_blank')
        },
        control(){
        let control = this.$router.resolve({
            path:'/realData',
            query:{
            serial_number:this.serialNumber,
            }
        })
        window.open(control.href,'_blank')
        },
        alert(){
        let alert = this.$router.resolve({
            path:'/alert',
            query:{
            serial_number:this.serialNumber,
            }
        })
        window.open(alert.href,'_blank')
        },
        charts(){
        let charts = this.$router.resolve({
            path:'/TrendChart',
            query:{
            serial_number:this.serialNumber,
            }
        })
        window.open(charts.href,'_blank')
        },
    }
}
</script>

<style lang="scss" scoped>
.containter{
    .el-row{
        border:solid 1px #F7F7F7;
        .el-col{
            font-size: 14px;
            padding: 5px 0 5px 5px;
            color: #172b4d;
        }
    }
}
.br{
    border-right:solid 1px #F7F7F7 ;
}
.bb{
    border-bottom:solid 1px #F7F7F7;
}
a { 
    text-decoration: none; 
} 
.router-link-active { 
    text-decoration: none; 
}
.el-button--small{
    padding: 0;
}
</style>